import { BaseMaintenanceApi } from './api.base';

export class BoxMaintenanceApi extends BaseMaintenanceApi {

}
